import { render, staticRenderFns } from "./full-calendar-component.vue?vue&type=template&id=24acc156&scoped=true"
import script from "./full-calendar-component.vue?vue&type=script&lang=js"
export * from "./full-calendar-component.vue?vue&type=script&lang=js"
import style0 from "./full-calendar-component.vue?vue&type=style&index=0&id=24acc156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24acc156",
  null
  
)

export default component.exports